/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Gender = {
  type: 'Enum',
} as const;
